import React, { useState } from 'react';
import ChromePic from "../../../../../assets/images/chrome.png";
import ModalEditWebsite from '../../modals/ModalEditWebsite';

const RestrictedWebsiteRow = ({item, handleWebUrlSelect, callFireStore}) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <tr>
            <td className="v-middle">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={item?.addUpdateTime}
                        name={item?.addUpdateTime}
                        checked={item?.isChecked || 0}
                        onChange={(e) => handleWebUrlSelect(e, item)}
                    />
                    <label
                        className="form-check-label d-inline-flex align-items-center"
                        htmlFor={item?.addUpdateTime}
                    >
                        <span 
                            className="icon-wrap rounded-3 flex-shrink-0 icon-sm me-2 p-1 overflow-hidden"
                        >
                            <img 
                                src={ChromePic} 
                                alt="avatar"
                            />
                        </span>
                        {item?.websiteUrl}
                    </label>
                </div>
            </td>
            <td className="v-middle text-end" onClick={() => setShowModal(true)}>
                <i className='icon-edit-one fs-5 me-3 pt-cursor text-blue-800' />
            </td>
            <ModalEditWebsite 
                item = {item}
                setShowModal = {setShowModal}
                showModal={showModal}
                callFireStore = {callFireStore}
            />
        </tr>
    )
}

export default RestrictedWebsiteRow